module.exports = __webpack_public_path__ + "static/img-profile-c3ba0113306523cdd9a63a2139ca7cf0.jpeg";